import d3 from "./d3.min.js";

// console.log("loaded splitBar.js");

export function splitbar(
  data,
  holderdiv,
  wholeheight,
  firstkey,
  secondkey,
  chartmeasure,
  view,
  colorrange,
  sortOrder
) {
  let splitColors = colorrange;

  if (!holderdiv || !$(holderdiv).length) {
    // console.error("Invalid holderdiv:", holderdiv);
    return;
  } else {
  }

  let stringed_id = String(holderdiv);
  // console.log("stringed_id", stringed_id);

  //clear out prev charts
  $(holderdiv).children().remove();

  let barpad = 0.3;

  let barheight = 33;

  let narrowformat = 450;

  // console.log("holderdiv", holderdiv);
  // console.log("holderdiv", d3.select(holderdiv));

  let width = d3.select(holderdiv).node().getBoundingClientRect().width;

  let adjustedLeft = width > narrowformat ? 300 : 5;
  let adjustedRight = "";
  //these get redefined depending on data length
  let height;
  let h;
  let m = [5, adjustedRight, 65, adjustedLeft]; //top right bottom left

  let w = width - m[1] - m[3] > 0 ? width - m[1] - m[3] : 0;
  // console.log("w", w);

  let color = d3.scaleOrdinal();
  let color1 = d3.scaleOrdinal();
  let color2 = d3.scaleOrdinal();

  //update the chart title for measure used

  let headertext = d3
    .select(holderdiv)
    .append("div")
    .attr("class", "col col-sm-12 headertext");

  // let headertext = holderdiv
  //   .append("div")
  //   .attr("class", "col col-sm-12 headertext");

  let charttitle = headertext
    .append("h6")
    .attr("class", "row chart-title")
    //offset title to align with bars not lables
    .style("padding-left", m[3] + 5 + "px")
    // .html('<span id="selectedmeasure">by race/ethnicy</span>');
    .html(d => `<span id="selectedmeasure">by ${data[0].values[0]['DisaggregationCategory']}</span>`);


  //chart setup not data dependent

  //tooltip moved to highest level so css position of children doesn't affect positioning
  //if there are lingering old ones, get rid

  d3.select(holderdiv).style("position", "relative");

  let tooltip = d3
    .select(holderdiv)
    .append("div")
    .attr("class", "tooltip")
    .attr("class", "tooltip")
    .style("position", "absolute")
    .style("z-index", "10");
  // .style("opacity", "0");

  // let legendholder = d3
  //   .select(holderdiv)
  //   .append("div")
  //   .attr("class", "col col-sm-12 legendholder")
  //   .style("text-transform", "uppercase")
  //   .style("padding-left", m[3] + "px")
  //   .style("padding-right", m[1] + "px");

  let svg = d3
    .select(holderdiv)
    .append("svg")
    .attr("class", "chart")
    .attr("id", "barchart")
    .attr("width", width);

  let g = svg
    .append("g")
    .attr("transform", "translate(" + m[3] + "," + m[0] + ")");

  let x = d3.scaleLinear().range([0, w]);

  let y = d3
    .scaleBand()
    .rangeRound([0, h])
    .paddingOuter(0)
    .paddingInner(barpad)
    .align(0.1);

  let stack = d3.stack().offset(d3.stackOffsetDiverging);

  let drawnX = g.append("g").attr("class", "axis axis--x");

  // let chartnote = d3
  //   .select(holderdiv)
  //   .append("div")
  //   .attr("class", "sources chartnote")
  //   .style("padding-left", m[3] + "px");
  // //.html("note here")

  // let beneCatMsg = chartnote
  //   .append("div")
  //   .attr("class", "beneCatMsg")
  //   .append("small");

  // let outOfStateMsg = chartnote
  //   .append("div")
  //   .attr("class", "outofstatenote")
  //   .attr("style", "padding-bottom: 1em;")
  //   .append("small");

  // let estPortMsg = chartnote
  //   .append("div")
  //   .attr("class", "est_portnote")
  //   .append("small");

  if (data.length > 0) {
    //elememts to update

    //this transitions out- here to prevent trying to use when not drawn yet
    d3.select(holderdiv);

    //        console.log('data before makechart', data)
    //         console.log('data filtered before makechart', data.filter(d => d.values[0][chartmeasure] !== 0))
    makechart(data, firstkey, secondkey, view);
  } else {
  } // end if data isn't empty

  function makechart(nesteddata, newfirstkey, newsecondkey, view) {
    // console.log(" nesteddata", nesteddata);

    //high to low sort
    //        nesteddata.sort((a,b) => b.values[0][chartmeasure] - a.values[0][chartmeasure])
    let allVal = nesteddata.find((d) => d.key === "All");
    let notAll = nesteddata.filter((d) => d.key !== "All");

    nesteddata.sort((a, b) => {
      let indexA = sortOrder.indexOf(a.key);
      let indexB = sortOrder.indexOf(b.key);

      return indexA - indexB;
    });

    //specific to top 10- estimated val per facil
    notAll.forEach(function (d) {
      // console.log("d.values[0] in nested for each", d.values[0]);

      d.values[0].testarray = d.values.map(function (c) {
        // console.log("c", c);
        return {
          //
          key: c,

          value: d.values[0][chartmeasure],
          state: c.state,
          name: c[newfirstkey],
        };
      });
    });

    // console.log("color", color);

    color.range(splitColors).domain(
      notAll.map(function (d) {
        return d.key;
      })
      // .sort(d3.descending)
    );

    // console.log("notAll", notAll);

    // console.log("color.domain", color.domain());
    // console.log("color.range", color.range());

    color1.domain(
      notAll[0].values.map(function (d) {
        return d.key;
      })
    );

    //console.log("color1.domain()", color1.domain());

    color2.domain(["thecolordom"]);
    //console.log("color2dom", color2.domain())

    height = barheight * notAll.length + m[0] + m[2];

    h = height - m[0] - m[2];

    y.rangeRound([0, h]);

    y.domain(
      notAll.map(function (d) {
        if (notAll.map != ["undefined"]) {
          return d.key;
        } else {
          return [0, 1];
        }
      })
    );

    svg.attr("height", height);

    function eachbardatadeal(data, key) {
      //console.log("data in eachbar", data, key);

      //what was this for?
      let newage = data.map(function (d) {
        //console.log("d in newage", d);
        // console.log("chartmeasure", chartmeasure);
        d.key = String(d.key);
        let lilarray = {};

        lilarray[d.key] = parseFloat(d.value);

        //chartmeasure = d[chartmeasure]
        // console.log("lilarray", lilarray);
        return lilarray;
      });
      // console.log("newage", newage);

      let nesteddataflat = newage.reduce(function (result, item) {
        let key = Object.keys(item)[0]; //first property: a, b, c
        result[key] = item[key];
        return result;
      }, {});

      // console.log("nesteddataflat", nesteddataflat);
      return nesteddataflat;
    } // end eachbardatadeal

    x.domain([
      0,
      d3.max(notAll, function (d) {
        //console.log("d", d);

        let innervals = notAll.map(function (d) {
          return parseFloat(d.values[0][chartmeasure]);
        });
        // console.log("innervals", innervals);
        return isNaN(d3.max(innervals)) ? 0 : d3.max(innervals);
      }),
    ]).nice();

    // console.log("x.domain", x.domain());
    // console.log("x.range", x.range());

    //initials
    let onerowAll = g.selectAll(".onerowg").data(notAll);
    onerowAll.exit().remove();

    //        let allbarsholder = onerowAll.select(".allbarsholderg");

    let rowlabelg = onerowAll.select(".rowlabelg");

    let rowlabels = rowlabelg.select(".rowlabels");

    //new ones

    let newrows = onerowAll.enter().append("g").attr("class", "onerowg");

    let newrowlabelg = newrows.append("g").attr("class", "rowlabelg");

    let newrowlabels = newrowlabelg.append("text").attr("class", "rowlabels");

    //merges
    //console.log('newrows', newrows)
    onerowAll
      .merge(newrows)
      .attr("id", function (d) {
        return d.key.replace(/\s/g, "");
      })
      .attr("transform", function (d) {
        if (d.key == "undefined") {
          return "translate(" + adjustedLeft + "," + 0 + ")";
        } else {
          return "translate(" + adjustedLeft + "," + y(d.key) + ")";
        }
      });

    onerowAll = g.selectAll(".onerowg");

    rowlabelg.merge(newrowlabelg);
    //redef
    rowlabelg = onerowAll
      .select(".rowlabelg")
      .style("font-weight", function (d) {
        return "";
      });

    rowlabels
      .merge(newrowlabels)
      .text(function (d) {
        if (d.key != "undefined") {
          return d.key;
        } else {
          return "";
        }
      })
      .attr("y", y.bandwidth() / 2 + 2)
      .attr("dx", "-.5em")

      .style("text-anchor", "end")
      //.style("font-weight", "bold")
      .style("text-transform", function () {
        if (newfirstkey == "state") {
          return "uppercase";
        } else {
          return "none";
        }
      });

    //redef
    rowlabels = rowlabelg.select(".rowlabels");
    //.call(wrap, m[3] * 0.5);

    rowlabels.selectAll("tspan").text(function (d) {
      let origtext = d3.select(this).text();
      return origtext.replace(/\s*$/, "");
    });

    let serie2 = onerowAll.selectAll(".serie2").data(function (d) {
      // console.log("d in serie2", d);
      let thisdata = eachbardatadeal(d.values[0].testarray, String(d.key));

      thisdata = [thisdata];

      //sort facilities alpha
      //            let alphakeys = d.values[0][secondkey].sort((a, b) => d3.ascending(a, b));
      //            console.log("alphakeys", alphakeys)

      let nonalphakeys = d.values[0].testarray;

      // console.log("nonalphakeys", nonalphakeys);
      // //
      // console.log("the stack", stack.keys(nonalphakeys)(thisdata));

      // return stack.keys(alphakeys)(thisdata)
      //test of not using the alpha sort here and relying on original nest sort
      return stack.keys(nonalphakeys)(thisdata);
    });

    serie2.exit().remove();
    //
    let serie2new = serie2.enter().append("g").attr("class", "serie2");

    serie2
      .merge(serie2new)
      .attr("id", function (d) {
        return d.key;
      })

      //			//let serie2 = serie.selectAll(".serie2")
      .transition("series2fill")
      .duration(800)
      .ease(d3.easePolyOut)
      .style("fill", function (d) {
        let parentdata = d3.select(this.parentNode).data();
        // console.log("parentdata", parentdata);
        //  let parentcat = parentdata[0].values[0].sing_mult;
        let parentcat = parentdata[0].key;
        //console.log('parentcat', parentcat)
        return color(parentcat);
      })
      .style("opacity", 1);

    //redef
    serie2 = onerowAll.selectAll(".serie2");

    let rectholders = serie2.selectAll(".rectholder").data(function (d) {
      // console.log("d in recthodler", d);
      return d;
    });
    //moved up here- buypass merge stuff for now

    //console.log("rectholders", rectholders)

    rectholders.exit().remove();

    let newrectholders = rectholders
      .enter()
      .append("g")
      .attr("class", "rectholder");

    let newrects = newrectholders.append("rect").attr("class", "thirdkeyrect");

    rectholders
      .merge(newrectholders)
      .attr("class", "rectholder")
      .attr("id", function (d) {
        //console.log("recholder d", d)
        return d.key + "_rectholder";
      });

    rectholders = serie2.selectAll(".rectholder");

    let rects = rectholders.select(".thirdkeyrect");

    rects
      .merge(newrects)

      //.merge(newrects)
      //.attr("pointer-events", "none")
      .attr("class", "thirdkeyrect")
      .classed("narrow", function (d) {
        // console.log('too narrow?', x(d[1]) - x(d[0]))
        if (x(d[1]) - x(d[0]) < 3) {
          // console.log("yep too narrow")
          return true;
        } else {
          return false;
        }
      })
      .style("pointer-events", "none")

      .attr("x", x(0))
      .attr("width", 0)
      .attr("height", y.bandwidth())
      .transition("rectsfill")
      .duration(800)
      .attr("x", function (d) {
        return isNaN(x(d[0])) ? 0 : x(d[0]);
      })
      .attr("width", function (d) {
        // console.log("d in newrect", d);
        // console.log("x(d[1]) - x(d[0])", x(d[1]) - x(d[0]));
        return isNaN(x(d[1])) ? 0 : x(d[1]) - x(d[0]);
      });

    rects = rectholders.selectAll(".thirdkeyrect");

    //console.log("rects", rects);

    //console.log("rectholders", rectholders);

    rectholders
      //.merge(rectholdersnew)
      .on("mousemove", function (d) {
        //let offset = $(this).parents(holderdiv).offset();

        //console.log("tooltip", $('.tooltip'));
        //				console.log("tooltip height", $('.tooltip').height());
        //

        let holderRect = d3.select(holderdiv).node().getBoundingClientRect();

        // Calculate the correct position by subtracting the container's offset
        let tooltipX = event.clientX - holderRect.left + 20; // Adding some offset for better visibility
        let tooltipY = event.clientY - holderRect.top - 80; // Adjusting Y position

        tooltip.style("left", tooltipX + "px").style("top", tooltipY + "px");
      })
      .on("mouseover", function (d) {
        d3.select(this)
          .select("rect")
          .transition()
          .duration(500)
          .ease(d3.easePolyOut)
          .style("stroke", "#ff5e50");

        let thiskey = d3.select(this.parentNode).data()[0].key;
        //console.log("thiskey", thiskey)
        let rowkey = d3.select(this.parentNode.parentNode).data()[0].key;
        //console.log("rowkey", rowkey)

        rowlabelg
          .filter(function (d) {
            return d.key == rowkey;
          })
          .transition()
          .duration(500)
          .ease(d3.easePolyOut)
          .style("font-weight", "bold");

        let rowdata = d3.select(this.parentNode.parentNode).data()[0];
        // console.log("rowdata", rowdata);

        //        let segmentData = d3.select(this.parentNode).data()[0];
        //        console.log("segmentData", segmentData);

        //this one specific to bars. not the same as pies
        const commaFormat = d3.format(",.0f");
        const pctFormat = d3.format(".1%");

        tooltip.html(
          "<span >" +
            rowdata.key +
            ": <b>" +
            pctFormat(rowdata.values[0][chartmeasure]) +
            "</b></span><br/>" +
            "<span ><i>(" +
            commaFormat(rowdata.values[0].instCount) +
            " of " +
            commaFormat(rowdata.values[0].twoPlusCt) +
            ")</i></span>"
        );

        tooltip.transition().duration(800).style("opacity", 1);
      })
      .on("mouseout", function () {
        rowlabelg
          .transition()
          .duration(500)
          .ease(d3.easePolyOut)
          .style("font-weight", "");

        d3.select(this)
          .select("rect")
          .transition()
          .duration(500)
          .transition()
          .ease(d3.easePolyOut)
          .ease(d3.easePolyOut)
          .style("stroke", "#fff");

        tooltip.transition().duration(600).delay(55).style("opacity", "0");
      });

    drawnX.selectAll(".xlabel").remove();

    drawnX
      .transition()
      .ease(d3.easePolyOut)
      .duration(850)
      //.call(d3.axisBottom(x).ticks(width / 100, "s")
      .call(
        d3
          .axisBottom(x)
          .ticks(width / 100)
          .tickFormat(function (d) {
            //this one specific to bars. not the same as pies
            const commaFormat = d3.format(".0%");
            return commaFormat(d);
          })
          .tickSize(h + 20)
      )

      //.tickformat(  return d3.format("$,.3s")(val).replace("G", "B");)
      .style("opacity", 1)
      .style("pointer-events", "none")
      .attr("transform", "translate(" + 0 + "," + -10 + ")");

    // drawnX.moveToFront();

    svg
      .selectAll(".tick")
      .select("text")
      .each(function () {
        //let thistext = d3.select(this).text();
        let thistext = $(this).text();
        //console.log("d3.select(this)", d3.select(this));
        //console.log("thistext", thistext);
        //	let inner = d3.select(this)._groups[0][0].innerHTML;
        let val = d3.select(this).data();
        //console.log(val);
      });

    //TODO axis label from data

    drawnX
      .append("text")
      .attr("class", "xlabel")
      .text(d => {
         return "% choosing " + data[0].values[0].twoPlusCat
    })
      .style("text-anchor", "middle")
      .attr("dx", w / 2)
      .attr("dy", h + 50);

    svg.select(".leglabel.totalslabel");
    //.call(wrap, m[1] * 0.85);

    $("#radioholder")
      .find("input." + view)
      .prop("checked", true);

    // drawnX.selectAll(".tick").selectAll("text").text("teapot");

    function resizer() {
      width = d3.select(holderdiv).node().getBoundingClientRect().width;

      //console.log("$(holderdiv).width();", $(holderdiv).width())
      //let m = [23, 100, 55, 400]; //top right bottom left

      // console.log("width", width);

      // these need to be redfined at resize
      adjustedLeft = width > narrowformat ? 300 : 5;
      //enough for ticks to not get cut off
      adjustedRight = width > narrowformat ? 20 : 20;

      m[3] = adjustedLeft;
      m[1] = adjustedRight;
      barpad = width > narrowformat ? 0.3 : 0.8;

      barheight = width > narrowformat ? 33 : 35;

      height = barheight * nesteddata.length + m[0] + m[2];

      h = height - m[0] - m[2];

      w =
        width - adjustedRight - adjustedLeft > 0
          ? width - adjustedRight - adjustedLeft
          : 0;
      // console.log("w", w);

      x.range([0, w]);

      y.rangeRound([0, h]).paddingInner(barpad);

      svg
        .attr("width", width)
        .attr("height", height)
        .transition("svgtrans")
        .duration(600)
        .on("end", function () {
          // console.log(" m[3] ", m[3]);
          g.attr("transform", "translate(" + m[3] + "," + m[0] + ")");

          drawnX
            .transition()
            .ease(d3.easePolyOut)
            .duration(850)
            .call(
              d3
                .axisBottom(x)
                .ticks(width / 100)
                .tickFormat(function (d) {
                  //this one specific to bars. not the same as pies
                  const commaFormat = d3.format(".0%");
                  return commaFormat(d);
                })
                .tickSize(h + 20)
            )
            .attr(
              "transform",
              "translate(" + 5 + "," + (width > narrowformat ? -10 : 10) + ")"
            );
          // .attr("transform", "translate(" + 0 + "," + ( -10 ) + ")");

          // drawnX.moveToFront();

          drawnX
            .select(".xlabel")
            .attr("dx", w / 2)
            .attr("dy", h + 50);

          onerowAll.attr("transform", function (d) {
            if (d.key == "undefined") {
              return "translate(" + 5 + "," + 0 + ")";
            } else {
              return "translate(" + 5 + "," + y(d.key) + ")";
            }
          });

          // since text is right aligned for wide format, it starts just to the left of the axis at wide
          let labelLeftOffset = width > narrowformat ? 0 : 20;

          //placement of row labels relative to bars for reg vs narrow view
          rowlabelg.attr(
            "transform",
            (d) =>
              "translate(" +
              labelLeftOffset +
              "," +
              (width > narrowformat ? 0 : y.bandwidth() * 2) +
              ")"
          );

          //  rowlabels.attr("y", (y.bandwidth() / 2) + 2)
          //rowlabels.attr("y", width > narrowformat ? y.bandwidth() / 2 + 2 : 0);
          rowlabels.attr("y", width > narrowformat ? y.bandwidth() / 2 + 2 : 0);

          rowlabels.style(
            "text-anchor",
            width > narrowformat ? "end" : "start"
          );

          rects.classed("narrow", function (d) {
            if (x(d[1]) - x(d[0]) < 3) {
              return true;
            } else {
              return false;
            }
          });

          rectholders.selectAll(".narrowbardot").remove();

          svg
            .selectAll(".thirdkeyrect")
            // .style("pointer-events", "none")
            .transition("rectsize")
            .ease(d3.easePolyOut)
            .duration(850)
            .attr("x", function (d) {
              return isNaN(x(d[0])) ? 0 : x(d[0]);
            })
            .attr("width", function (d) {
              return isNaN(x(d[1])) ? 0 : x(d[1]) - x(d[0]);
            })
            .attr("y", width > narrowformat ? 0 : barheight - y.bandwidth())
            .attr("height", y.bandwidth())
            .style("stroke-width", function (d) {
              x(d[1]) - x(d[0]) < 2 ? ".1" : 1;
            })
            .on("end", function () {
              d3.select(this)
                .transition("pe")
                .delay(1)
                .duration(1)
                .style("pointer-events", "all");
            });

          svg
            .select(".rowlabels.ageslabel")
            //if we set responsive text size this might need to change
            .attr("x", -(w + 20));

          svg.select(".leglabel.totalslabel");
          //.call(wrap, m[1] * 0.85);
          // fo.attr("x", width > narrowformat ? -18 : -32);

          charttitle.style(
            "padding-left",
            width > narrowformat ? adjustedLeft : m[3] + 5 + "px"
          );
          //these need the bootstrap col padding restored
          //  legendholder.style("padding-left", width > narrowformat ? m[3] : "15px");
          // chartnote.style(
          //   "padding-left",
          //   width > narrowformat ? adjustedLeft : "15px"
          // );
        }); //end on end of transition
    } //end resizer

    //http://jsfiddle.net/fq882/652/
    let doit;

    function resizedw() {
      // console.log("resize end")
      resizer();
    }

    resizedw();

    //window.onresize = function() {
    $(window).on("resize", function () {
      clearTimeout(doit);
      doit = setTimeout(function () {
        resizedw();
      }, 20);
    });
  } //end makechart
} // end hundpctbar
